module.exports = __webpack_public_path__ + "img/selected6-min.3168a204.png";